import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { FgInspectionDto } from ".";

export class AllFgInspectionsResponse extends GlobalResponseObject{
    data?: FgInspectionDto[];

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
     constructor(status: boolean, intlCode: number, internalMessage: string, data?: FgInspectionDto[]){
        super(status,intlCode,internalMessage)
        this.data = data;
    }
}